// @flow

import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PageHeader from '../../components/page-header';
import type { Props } from '.';
import './possiblematches.scss';

export default class PossibleMatches extends Component<Props> {
  props: Props;

  formatTitle(title) {
    return title
      .toLowerCase()
      .replace(/((^|[\s(])\w)/g,
        v => v.toUpperCase());
  }

  openWork(iceWorkKey) {
    const { resetWorkTabs, updateSearchParam, resetSearchPrams } = this.props;
    resetWorkTabs();
    resetSearchPrams();
    updateSearchParam('workNumber', iceWorkKey);
    updateSearchParam('workNumberType', 'ICE');
  }

  render() {
    const {
      workMatches,
      backLinkOnClick,
      backLinkText,
      backLinkTo,
    } = this.props;
    return (
      <section className="main-content possible-matches d-flex flex-column">
        <PageHeader
          title="Possible Matches"
          iconClassName="prs-icon-matches"
          backLinkTo={backLinkTo}
          backLinkText={backLinkText}
          backLinkOnClick={backLinkOnClick}
        />
        <div className="search-pane flex-grow-1">
          <div className="container">
            <h4>
              {workMatches.length}
              {' '}
              <span className="smaller">results</span>
            </h4>
            <div className="search-card-list">
              {workMatches.map(({ workTitle, iceWorkKey, workTunecode }) => (
                <NavLink to="/possiblematch" onClick={this.openWork(iceWorkKey)} key={iceWorkKey} className="search-card">
                  <h5>{this.formatTitle(workTitle)}</h5>
                  <p>
                    <strong>Tunecode: </strong>
                    {workTunecode}
                  </p>
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
